import { IRemoveQuestion } from '@/contracts/modules/education/use-case/IRemoveQuestion'
import { RemoveQuestionRoute } from '@/modules/education/v1/api/v1/questions/RemoveQuestion/RemoveQuestionRoute'

export class RemoveQuestion implements IRemoveQuestion {
  async exec(question: string): Promise<string> {
    const response = await new RemoveQuestionRoute(question).exec(null)
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData().uuid
  }
}
